export const PORTAL = {
  bumeran: 1,
  zonajobs: 2,
  hr: 3
};

export const typesDocuments = [
  {
    value: 'dni',
    label: 'Documento de identidad'
  },
  {
    value: 'passport',
    label: 'Pasaporte'
  },
  {
    value: 'foreignId',
    label: 'Cédula extranjera'
  },
  {
    value: 'other',
    label: 'Otro'
  }
];

export const typesPhone = [
  {
    value: 'Celular/Movil',
    label: 'Celular/Móvil'
  },
  {
    value: 'Linea fija',
    label: 'Línea fija'
  }
];

export const bumeranCv = {
  education: {
    status: {
      graduated: 2,
      inCourse: 1,
      aborted: 3
    }
  }
};

export const stepOneRequired = [
  'fotoURL',
  'foto_perfil',
  'firstname',
  'lastname',
  'email',
  'dni',
  'prefix_phone_1',
  'phone',
  'type_phone_1',
  'prefix_phone_2',
  'phone_2',
  'type_phone_2',
  'kudertActivo',
  'gender',
  'nationality',
  'location',
  'permanent_address',
  'born',
  'bornObj',
  'discapacidad'
];
